module.exports = __webpack_public_path__ + "img/background_select.56f87875.png";